
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const RecipeVariations = () => {
  return (
    <>
      <h2 className="text-2xl font-medium mb-4">Variations and Ideas</h2>
      <div className="grid md:grid-cols-2 gap-6 mb-8">
        <Card>
          <CardHeader>
            <CardTitle>Flavor Variations</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-5 text-muted-foreground space-y-2">
              <li>Add 1 tsp of lemon or orange zest for citrus-infused cookies</li>
              <li>Replace almond extract with coconut extract</li>
              <li>Add ½ tsp of ground ginger for a subtle spice</li>
              <li>Incorporate 1 tbsp of matcha powder for green tea fortune cookies</li>
            </ul>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>Fortune Ideas</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-5 text-muted-foreground space-y-2">
              <li>Wedding proposals or announcements</li>
              <li>Custom birthday messages</li>
              <li>Holiday-themed fortunes</li>
              <li>Motivational quotes for special events</li>
              <li>Inside jokes for friends and family</li>
            </ul>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default RecipeVariations;
